import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@spartacus/core';

import { KnBrConfirmDialogComponent } from './kn-br-confirm-dialog.component';

@NgModule({
  declarations: [KnBrConfirmDialogComponent],
  imports: [CommonModule, I18nModule],
})
export class KnBrConfirmDialogModule {}
